import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ELegalForm } from '../../../repositories/dailyrent/entities/request/PublicV1ReceiptDetailsSaveRequestSchema';
import { fetchInitialFormData } from '../../../thunks/joinOtaIndividual/fetchInitialFormData/';
import { saveFormAndAcceptOffer } from '../../../thunks/joinOtaIndividual/saveFormAndAcceptOffer';

export interface IFormDataState {
  email: string;
  firstName: string;
  inn: string;
  lastName: string;
  patronymic: string;
  phone: string;
  legalForm?: ELegalForm.PhysicalPerson | ELegalForm.SelfEmployed;
  innError?: string | null;

  submitDisabled: boolean;
}

export const initialState: IFormDataState = {
  email: '',
  firstName: '',
  inn: '',
  lastName: '',
  patronymic: '',
  phone: '',
  legalForm: undefined,
  innError: null,

  submitDisabled: false,
};

const formDataSlice = createSlice({
  name: 'formData',
  initialState,
  reducers: {
    setFormData(state, action: PayloadAction<Omit<IFormDataState, 'submitDisabled'>>) {
      return {
        ...state,
        email: action.payload.email,
        firstName: action.payload.firstName,
        inn: action.payload.inn,
        lastName: action.payload.lastName,
        patronymic: action.payload.patronymic,
        phone: action.payload.phone,
        legalForm: action.payload.legalForm,
      };
    },
    setInnError(state, action: PayloadAction<string | null>) {
      state.innError = action.payload;
    },
    setLegalForm(state, action: PayloadAction<ELegalForm.PhysicalPerson | ELegalForm.SelfEmployed>) {
      state.legalForm = action.payload;
    },
  },
  extraReducers(builder) {
    builder.addCase(fetchInitialFormData.fulfilled, (state, action) => {
      state.email = action.payload.email || '';
      state.firstName = action.payload.firstName || '';
      state.inn = action.payload.inn || '';
      state.lastName = action.payload.lastName || '';
      state.patronymic = action.payload.patronymic || '';
      state.phone = action.payload.phone || '';
      state.legalForm = action.payload.legalForm as ELegalForm.PhysicalPerson | ELegalForm.SelfEmployed;
    });

    builder.addCase(saveFormAndAcceptOffer.fulfilled, state => {
      state.submitDisabled = true;
    });
  },
});

export const {
  reducer: formDataReducer,
  actions: { setFormData, setInnError, setLegalForm },
} = formDataSlice;
